import React, { createContext, useContext, useMemo, useState } from 'react';
import { DataEnvironment } from 'types/DataEnvironment';

type DataEnvironmentState = DataEnvironment | undefined;
type ContextValue = [
  DataEnvironmentState,
  React.Dispatch<React.SetStateAction<DataEnvironmentState>>,
];
type DataEnvironmentProviderProps = { children: React.ReactNode };

const DataEnvironmentContext = createContext<ContextValue | undefined>(undefined);

function DataEnvironmentProvider({ children }: DataEnvironmentProviderProps) {
  const [dataEnvironment, setDataEnvironment] = useState<DataEnvironmentState>();
  const value = useMemo<ContextValue>(() => [dataEnvironment, setDataEnvironment], [
    dataEnvironment,
    setDataEnvironment,
  ]);

  return (
    <DataEnvironmentContext.Provider value={value}>{children}</DataEnvironmentContext.Provider>
  );
}

function useDataEnvironment() {
  const context = useContext(DataEnvironmentContext);

  if (context === undefined) {
    throw new Error('useDataEnvironment must be used within a DataEnvironmentProvider');
  }

  return context;
}

export { DataEnvironmentProvider, useDataEnvironment };
